<template>
	<v-card class="ma-3">
		<v-card-title class="pa-0 card-header-details" style="height: 42px">
			<v-col cols="7" class="pa-0">
				<span class="float-left font-size14 font-weight-bold ml-4">{{ $t('medication-summary') }}</span>
			</v-col>
			<v-col cols="5" class="pa-0 pr-3 d-flex align-center justify-end">
				<v-btn class="mr-1 color-primary" x-small @click="$emit('openViewAllMedicationsDialog')">
					<v-icon x-small>mdi-eye</v-icon> {{ $t('view-all') }}
				</v-btn>
				<v-icon
					:disabled="detailedUser.userData.status === 99"
					@click="synchronizeDrawers('medicationAdd')"
					class="float-right"
					color="primary"
					size="18px">
					mdi-plus-circle
				</v-icon>
			</v-col>
		</v-card-title>
		<v-data-table
			:loading="loading"
			:headers="headers"
			:no-data-text="$t('no-data-available')"
			:loading-text="$t('loading')"
			:items="prescriptions"
			:items-per-page="-1"
			sort-by="id"
			:sort-desc="true"
			item-key="id"
			fixed-header
			style="width: 100%; overflow-y: auto"
			dense
			:height="height"
			class="medical-staff-data-table"
			hide-default-footer>
			<template v-slot:item="{ item, index }">
				<tr :class="getRowsForDataTable(index)" @click="$emit('openMedicationEditDialog', item)">
					<td class="font-size13 text-left pl-1 pr-1">
						<span>{{ item.brandName }}</span>
					</td>
					<td class="font-size13 text-left pl-1 pr-1">
						<span>{{ item.dosage }}</span>
					</td>
					<td class="font-size13 text-left pl-1 pr-1">
						<span>{{ item.medicalStaffFullName }}</span>
					</td>
					<td class="font-size13 text-left pl-1 pr-1">
						<span>{{ formatDate(item.prescribedAt) }}</span>
					</td>
				</tr>
			</template>
		</v-data-table>
	</v-card>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import { getRowsForDataTable } from '@/utils/utilities';
import { formatterFilter } from '@/utils/luxon-formater';
export default {
	name: 'MedicationList',
	props: {
		height: {
			type: String,
		},
	},
	data () {
		return {
			loading: false,
		};
	},
	computed: {
		...mapGetters({
			pageHeight: 'pageHeight',
		}),
		...mapState({
			detailedUser: (state) => state.users.detailedUser,
			prescriptions: (state) => state.prescriptions.prescriptions,
		}),
		getTreatmentSummary () {
			return this.detailedUser.userData.patientMetadata.prescriptions;
		},
		headers () {
			const headers = [
				{
					text: this.$t('prescription-brand-name'),
					value: 'brandName',
					class: 'table-header',
					align: 'start pl-1 pr-1',
				},
				{
					text: this.$t('dosage'),
					value: 'dosage',
					class: 'table-header',
					align: 'start pl-1 pr-1',
				},
				{
					text: this.$t('prescribed-by'),
					value: 'medicalStaffFullName',
					class: 'table-header pl-1 pr-1',
					sortable: false,
				},
				{
					text: this.$t('prescribed-on'),
					value: 'prescribedAt',
					class: 'table-header pl-1 pr-1',
				},
			];
			return headers;
		},
		timeLocalization () {
			return this.$i18n.locale;
		},
	},
	async mounted () {
		await this.getPrescriptionsByPatientId(this.detailedUser.userData.patientMetadata.userId);
	},
	methods: {
		getRowsForDataTable,
		...mapActions({
			getPrescriptionsByPatientId: 'prescriptions/getPrescriptionsByPatientId',
		}),
		formatDate (val) {
			const dateObject = new Date(val);
			return formatterFilter(dateObject, 'date_med', this.timeLocalization, null);
		},
		synchronizeDrawers (drawer) {
			this.$store.commit('SET_PATIENT_DETAILS_DRAWER', drawer);
			this.$store.commit('SET_UPDATE_DETAILS_DRAWER', {
				updateDrawer: true,
				page2: 'patientdetails',
			});
		},
	},
};
</script>
